import { StoreInterface } from "../../models";

export const getPageContentGeneratorData = (store: StoreInterface) =>
  store.pageContentGenerator;
